export default [{
  path: '/calendar-app',
  name: 'CalendarApp',
  meta: { 
    label: 'Calendar App',
    icon: 'cil-calendar'
  },
  component: () => import('../../../views/calendar/CalendarApp.vue')
}]
